import { ExtraParamsKeys, IExtraParams } from "../../interfaces/type1/IQueryParams";

export interface INavMenuRoute {
    Title: string,
    SubTitle: string
    URL: string
    ImageClass: string
    Help: string,
    ExtraParams?: IExtraParams[]
}


export class HeadersRoutes {
    public static GetRoutes(): INavMenuRoute[] {
        return [
            {
                ImageClass: "nav-icon pi pi-calendar",
                Title: "Atos Praticados",
                SubTitle: "Somatória de valores agrupados por ato",
                URL: "/v1/atos_praticados",
                Help: `Este relatório exibe os itens executados dentro do período selecionado. 
                
Os valores apresentados são de emolumentos, sem considerar os encargos. 

E ao final é exibido o ranking dos itens que geram maiores receitas para o cartório.`,
                ExtraParams: [{ Key: ExtraParamsKeys.OS_QUITADAS_APENAS, Value: true }, { Key: ExtraParamsKeys.INCLUIR_ITENS_GRATUITOS, Value: true, Label: "Incluir atos gratuitos" }]
            },
            {
                ImageClass: "nav-icon pi pi-tags",
                Title: "Atos Gratuitos Praticados",
                SubTitle: "Quantidade de atos praticados",
                URL: "/v1/atos_gratuitos",
                Help: `Esse gráfico/relatório apresenta os atos gratuitos realizados no período selecionado. 

E no final é exibido um gráfico de pizza com o ranking dos 5 atos gratuitos mais frequentes, permitindo analisar o impacto desses atendimentos no volume geral de serviços prestados pelo cartório.`
            },
            {
                ImageClass: "nav-icon pi pi-stopwatch",
                Title: "OSs por Hora",
                SubTitle: "Quantidade de OS abertas por hora",
                URL: "/v1/os_hora",
                Help: `Esse relatório/gráfico mostra a quantidade de Ordens de Serviço abertas para cada hora do dia, no período filtrado. 

Esse dado é útil para identificar horários de maior demanda, possibilitando ao cartório otimizar escalas de trabalho, planejar recursos de atendimento e melhorar a distribuição da equipe.`
            },
            {
                ImageClass: "nav-icon pi pi-users",
                Title: "Atos por Usuário",
                SubTitle: "Somatória de valores de atos executados por usuário",
                URL: "/v1/atos_por_usuario",
                Help: `Esse relatório/gráfico apresenta os valores e quantidades de atos executados no período. 

Os valores apresentados são baseados apenas nos emolumentos, ou seja, os valores não contemplam os encargos. 

Ao final é exibido um gráfico de pizza com o ranking dos 5 funcionários que geraram mais receitas para o cartório. Esses atos são agrupados pelo usuário que executou o item.

Estas informações possibilitam acompanhar o desempenho individual, identificar usuários com maior volume de atuação e auxiliar na gestão de produtividade.`,
                ExtraParams: [{ Key: ExtraParamsKeys.OS_QUITADAS_APENAS, Value: true }, { Key: ExtraParamsKeys.INCLUIR_ITENS_GRATUITOS, Value: true, Label: "Incluir atos gratuitos" }]

            },
            {
                ImageClass: "nav-icon pi pi-bolt",
                Title: "Desempenho por Usuário",
                SubTitle: "Quantidade de OSs atendidas por usuário",
                URL: "/v1/desempenho_usuario",
                Help: `Este gráfico/relatório mostra o volume de OSs atendidas por cada usuário no período selecionado. 

Os valores apresentados são baseados apenas nos emolumentos, ou seja, os valores não contemplam os encargos. 

No final, o gráfico de pizza  destaca os 5 usuários mais produtivos, enquanto o relatório traz informações completas de todos os membros da equipe. Esse recurso ajuda a acompanhar produtividade, reconhecer destaques e identificar oportunidades de treinamento ou ajustes na equipe. `,
                ExtraParams: [{ Key: ExtraParamsKeys.OS_QUITADAS_APENAS, Value: true }, { Key: ExtraParamsKeys.INCLUIR_ITENS_GRATUITOS, Value: true, Label: "Incluir atos gratuitos" }]

            },

            {
                ImageClass: "nav-icon pi pi-chart-line",
                Title: "Entradas",
                SubTitle: "Entradas agrupadas por descrição dos itens",
                URL: "/v1/recursos",
                Help: `Esse relatório apresenta a quantidade de itens da ordem de serviço executados e lançamentos manuais.

Os valores apresentados são baseados apenas nos emolumentos, ou seja, os valores não contemplam os encargos. 

Os valores são agrupados conforme o emolumento, permitindo analisar a origem das receitas, identificar quais atividades geram mais entrada de recursos e acompanhar a saúde financeira da serventia.`,
                ExtraParams: [{ Key: ExtraParamsKeys.OS_QUITADAS_APENAS, Value: true }]
            },
            {
                ImageClass: "nav-icon pi pi-wallet",
                Title: "Saídas",
                SubTitle: "Somatórios dos valores agrupados por plano de contas",
                URL: "/v1/desembolsos",
                Help: `Esse relatório exibe as despesas realizadas no período filtrado, apresentadas do maior para o menor valor. 

Os lançamentos são agrupados pelo plano de contas e, quando não existe classificação, são agrupados no item “Não Classificado”. 

Esse relatório permite analisar os principais gastos, monitorar despesas recorrentes e avaliar oportunidades de redução de custos.`
            },
            {
                ImageClass: "nav-icon pi pi-chart-bar",
                Title: "Evolução das Entradas e Saídas",
                SubTitle: "Entradas e saídas agrupadas por dia",
                URL: "/v1/desempenho_serventia",
                Help: `Esse relatório apresenta a evolução das entradas e saídas ao longo do tempo. 

Dependendo do filtro aplicado, a visualização pode ser diária, semanal, mensal ou anual. Esse gráfico permite analisar tendências financeiras, identificar períodos de maior ou menor fluxo de caixa e avaliar o equilíbrio entre entradas e saídas de recursos.`,
                ExtraParams: [{ Key: ExtraParamsKeys.OS_QUITADAS_APENAS, Value: true }]
            },
            {
                ImageClass: "nav-icon pi pi-money-bill",
                Title: "Selos por Dia",
                SubTitle: "Selos utilizados/enviados por dia",
                URL: "/v1/selos_por_dia",
                Help: `Esse relatório mostra a quantidade de selos utilizados em comparação com a quantidade de selos enviados no período selecionado. 

Essa informação permite acompanhar o consumo de selos, verificar regularidade no uso e identificar eventuais diferenças entre selos enviados e efetivamente utilizados.`
            },
            {
                ImageClass: "nav-icon pi pi-list",
                Title: "Senhas por Fila",
                SubTitle: "Volume de senhas emitidas por fila",
                URL: "/v1/filas_volume",
                Help: `Esse gráfico mostra a quantidade de senhas emitidas por fila no período selecionado.

        Ao clicar em uma barra, é exibido o tempo médio de espera daquela fila. Esse relatório ajuda a identificar quais filas recebem maior demanda e quais setores concentram mais atendimentos.`
            },
            {
                ImageClass: "nav-icon pi pi-clock",
                Title: "Espera por Fila",
                SubTitle: "Tempo médio de espera por fila",
                URL: "/v1/filas_tempo_espera",
                Help: `Esse gráfico mostra o tempo médio de espera de cada fila no período selecionado.

    O tempo é calculado entre a emissão da senha e a chamada para atendimento. Ao clicar em uma barra, é exibida a quantidade de atendimentos considerada no cálculo. Esse relatório ajuda a identificar gargalos no atendimento.`
            },
            {
                ImageClass: "nav-icon pi pi-stopwatch",
                Title: "Atendimentos por Hora",
                SubTitle: "Quantidade de atendimentos agrupados por hora",
                URL: "/v1/filas_atendimentos_hora",
                Help: `Esse gráfico mostra a quantidade de senhas chamadas em cada hora do dia no período selecionado.

    Ao clicar em uma barra, é exibido o tempo médio de espera das senhas chamadas naquele horário. Esse relatório ajuda a identificar horários de maior movimento e ajustar a equipe de atendimento.`
            },
            {
                ImageClass: "nav-icon pi pi-times-circle",
                Title: "Cancelamentos por Fila",
                SubTitle: "Cancelamentos e motivo mais frequente",
                URL: "/v1/filas_cancelamentos",
                Help: `Esse gráfico mostra a quantidade de senhas canceladas por fila no período selecionado.

    São consideradas canceladas as senhas que possuem motivo de cancelamento informado. Ao clicar em uma barra, é exibido o motivo de cancelamento mais frequente daquela fila.`
            },
            {
                ImageClass: "nav-icon pi pi-user",
                Title: "Atendimentos por Usuário",
                SubTitle: "Quantidade de atendimentos por usuário",
                URL: "/v1/filas_atendimentos_usuario",
                Help: `Esse gráfico mostra a quantidade de atendimentos concluídos por usuário no período selecionado.

    Ao clicar em uma barra, é exibida a duração média dos atendimentos daquele usuário. Esse relatório ajuda a acompanhar produtividade e distribuição dos atendimentos entre a equipe.`
            },
            {
                ImageClass: "nav-icon pi pi-check-circle",
                Title: "SLA por Fila",
                SubTitle: "Percentual de atendimentos em até 10 minutos",
                URL: "/v1/filas_sla_10_minutos",
                Help: `Esse gráfico mostra o percentual de senhas atendidas em até 10 minutos por fila.

    Ao clicar em uma barra, é exibido o tempo médio de espera daquela fila. Esse relatório ajuda a avaliar a qualidade e a agilidade do atendimento.`
            }, 
            {
                ImageClass: "nav-icon pi pi-hourglass",
                Title: "Senhas Aguardando",
                SubTitle: "Quantidade aguardando por fila",
                URL: "/v1/filas_aguardando",
                Help: `Esse gráfico mostra a quantidade de senhas que ainda estão aguardando atendimento hoje, agrupadas por fila.

            Ao clicar em uma barra, é exibido o maior tempo de espera atual daquela fila. Esse relatório é útil para acompanhar gargalos em tempo real e identificar filas que precisam de atenção imediata.`, 
            ExtraParams: [{Key: ExtraParamsKeys.SEM_FILTRO_DATA, Value: true}]
            }
        ];
    }

}